module.exports = __webpack_public_path__ + "img/legion_field.f10aee69.jpg";